import axios, { AxiosResponse } from 'axios';

import endpoints from 'src/constants/apiEndpoints';
import {
  TAddWorkspaceAccessBody,
  TAddWorkspaceBody,
  TEditWorkspaceAccessBody,
  TEditWorkspaceBody
} from 'src/interfaces/workspacesReduxShapes';

export const getCompanyWorkspacesHelper = (): Promise<AxiosResponse> => {
  return axios.get(endpoints.GET_COMPANY_WORKSPACES);
};

export const getUserWorkspacesHelper = (): Promise<AxiosResponse> => {
  return axios.get(endpoints.GET_USER_WORKSPACES);
};

export const addWorkspaceHelper = (body: TAddWorkspaceBody): Promise<AxiosResponse> => {
  return axios.post(endpoints.ADD_COMPANY_WORKSPACE, body);
};

export const editWorkspaceHelper = (id: string, body: TEditWorkspaceBody): Promise<AxiosResponse> => {
  return axios.patch(endpoints.EDIT_COMPANY_WORKSPACE(id), body);
};

export const deleteWorkspaceHelper = (id: string): Promise<AxiosResponse> => {
  return axios.delete(endpoints.DELETE_COMPANY_WORKSPACE(id));
};

export const getWorkspaceAccessesHelper = (id: string): Promise<AxiosResponse> => {
  return axios.get(endpoints.GET_COMPANY_WORKSPACE_ACCESSES(id));
};

export const addWorkspaceAccessHelper = (id: string, body: TAddWorkspaceAccessBody): Promise<AxiosResponse> => {
  return axios.post(endpoints.ADD_COMPANY_WORKSPACE_ACCESS(id), body);
};

export const editWorkspaceAccessHelper = (
  workspaceId: string,
  userId: string,
  body: TEditWorkspaceAccessBody
): Promise<AxiosResponse> => {
  return axios.put(endpoints.EDIT_COMPANY_WORKSPACE_ACCESS(workspaceId, userId), body);
};

export const deleteWorkspaceAccessHelper = (workspaceId: string, userId: string): Promise<AxiosResponse> => {
  return axios.delete(endpoints.DELETE_COMPANY_WORKSPACE_ACCESS(workspaceId, userId));
};
